import { FC } from 'react'
import { Show, useLocale, useShowContext } from 'react-admin'

import { formatDay } from '../../domain/activeInspectionCells'
import { Locale } from '../../i18n'
import type { HistoricalInspection } from '../../models/inspection'
import { LoadingDisplay } from '../atoms/LoadingDisplay'
import { HistoricalInspectionDetails } from '../pages/HistoricalInspectionDetails'

export const ShowRecord: FC = () => {
  const context = useShowContext<HistoricalInspection>()
  const locale = useLocale() as Locale
  const record = context.record
  if (!record) return <LoadingDisplay />

  return <HistoricalInspectionDetails record={record} locale={locale} />
}

export const HistoricalInspectionDetailsTitle: FC = () => {
  const context = useShowContext<HistoricalInspection>()
  const record = context.record
  if (!record) return null
  const date = formatDay(record.day)
  return (
    <span>
      {date} {record.container}
    </span>
  )
}

export const HistoricalInspectionShow = () => {
  return (
    <Show title={<HistoricalInspectionDetailsTitle />}>
      <ShowRecord />
    </Show>
  )
}
